import * as React from 'react';

import styles from './divider.module.css';

export function And() {
    return <div className={styles.divider}>and</div>;
}
